
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"13","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.375 9.126v-2.24m-1.324-4.53l-1.24-1.239A1.867 1.867 0 004.491.57H3.242c-1.03 0-1.867.836-1.867 1.867v7.933c0 1.031.836 1.867 1.867 1.867H13.51a1.867 1.867 0 001.867-1.867v-5.6c0-1.03-.836-1.866-1.867-1.866H8.37c-.495 0-.97-.197-1.32-.547z","stroke":"#293343","stroke-width":".933","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('circle',{attrs:{"cx":"8.375","cy":"5.371","r":".5","fill":"#293343"}})])
          )
        }
      }
    